import styles from './AccordionHeader.module.scss';

interface HeaderProps {
  title: string;
  subtitle: string;
}

export const AccordionHeader = ({ title, subtitle }: HeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  );
};

export default AccordionHeader;
